import React from "react";
import { useNavigate } from "react-router-dom";
import { Box ,TextField} from "@mui/material";
import TableSub from "../../components/TableSub/TableSub";
import { useState } from "react";
;


const SubcatSearch = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
  const buttonStyle = {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "5px",
    cursor: "pointer",
    fontFamily: "Roboto",
    transition: "background-color 0.3s ease",
};


  const buttonHoverStyle = (event, isHovering) => {
    event.target.style.backgroundColor = isHovering ? "#0056b3" : "#007bff";
  };

  return (
    <div>
      <h1 style={{ fontFamily: "Roboto"}}>Subcategory</h1>
    
      <button
        onClick={() => navigate("/add-subcategory")}
        style={buttonStyle}
        onMouseEnter={(e) => buttonHoverStyle(e, true)}
        onMouseLeave={(e) => buttonHoverStyle(e, false)}
      >
        Create New Subcategory
      </button>
      <Box className="search-container">
      <TextField
          label="Search"
          variant="outlined"
          margin="normal"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        </Box>
    
      <TableSub searchTerm={searchTerm} />
      
      
      
      

       
              
           
        </div>
    );
};
export default SubcatSearch;
